const inBox = () => import(/* webpackChunkName: "afterSales" */ '../views/after-sales/in-box/index.vue')
const writeEmail = () => import(/* webpackChunkName: "afterSales" */ '../views/after-sales/in-box/write-email.vue')
const serviceEmail = () => import(/* webpackChunkName: "afterSales" */ '../views/after-sales/service-email/index.vue')
const emailDetail = () => import(/* webpackChunkName: "afterSales" */ '../views/after-sales/detail/index.vue')
const afterSaleList = () => import(/* webpackChunkName: "afterSales" */ '../views/after-sales/list/index.vue')

const serviceSetting = () => import(/* webpackChunkName: "afterSales" */ '../views/after-sales/after-sales-set/index.vue')
const emailSetting = () => import(/* webpackChunkName: "afterSales" */ '../views/after-sales/email-setting/index.vue')
export default [
  {
    path: 'after-sales',
    name: 'after-sales',
    meta: {
      name: '售后管理',
      keepAlive: true
    },
    redirect: { name: 'in-box' }
  },
  {
    path: '/in-box',
    name: 'in-box',
    meta: {
      menuData: 'after-sales',
      name: '收件箱',
      keepAlive: true
    },
    component: resolve => require(['../views/after-sales/in-box/index.vue'], resolve)
  },
  {
    path: 'write-email',
    name: 'write-email',
    meta: {
      parentsName: 'in-box',
      backName: 'in-box',
      name: '写信',
      keepAlive: true
    },
    component: resolve => require(['../views/after-sales/in-box/write-email.vue'], resolve)
  },
  {
    path: 'reply-email',
    name: 'reply-email',
    meta: {
      parentsName: 'in-box',
      backName: 'in-box',
      name: '回信',
      keepAlive: true
    },
    component: resolve => require(['../views/after-sales/in-box/write-email.vue'], resolve)
  },
  {
    path: 'service-email',
    name: 'service-email',
    meta: {
      name: '客服邮箱',
      keepAlive: true
    },
    component: serviceEmail
  },
  {
    path: 'email-detail',
    name: 'email-detail',
    meta: {
      parentsName: 'in-box',
      backName: 'in-box',
      name: '详情',
      keepAlive: true
    },
    component: emailDetail
  },
  {
    path: 'after-sales-set',
    name: 'after-sales-set',
    meta: {
      name: '售后设置',
      keepAlive: true
    },
    component: serviceSetting
  },
  {
    path: 'email-setting',
    name: 'email-setting',
    meta: {
      name: '邮件设置',
      keepAlive: true
    },
    component: emailSetting
  },
  {
    path: 'after-sale-list',
    name: 'after-sale-list',
    meta: {
      name: '售后订单',
      keepAlive: true
    },
    component: afterSaleList
  },
  {
    path: 'add-after-order/:orderNo',
    name: 'add-after-order',
    meta: {
      name: '新增售后订单',
      backName: 'after-sale-list',
      parentsName: 'after-sales',
      keepAlive: true
    },
    component: () => import('../views/after-sales/add-after-order/index.vue')
  },
  {
    path: 'add-after-order',
    name: 'add-after-order',
    meta: {
      name: '新增售后订单',
      backName: 'after-sale-list',
      parentsName: 'after-sales',
      keepAlive: true
    },
    component: () => import('../views/after-sales/add-after-order/index.vue')
  },
  {
    path: 'edit-after-order/:id',
    name: 'edit-after-order',
    meta: {
      name: '编辑售后单',
      backName: 'after-sale-list',
      parentsName: 'after-sales',
      keepAlive: true
    },
    component: () => import('../views/after-sales/add-after-order/index.vue')
  },
  {
    path: 'after-order-detail/:id',
    name: 'after-order-detail',
    meta: {
      name: '售后订单详情',
      backName: 'after-sale-list',
      parentsName: 'after-sales',
      keepAlive: true
    },
    component: () => import('../views/after-sales/after-order-detail/index.vue')
  },
]
